import {
  Grid,
  ListItem,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(1),
    alignItems: "center",
  },
  def: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    borderBottom: "none",
    color: "inherit",
    padding: (props) => theme.spacing(props.compact ? 0.5 : 1),
    textTransform: "capitalize",
  },
  heading: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    textAlign: "start",
    color: "inherit",
    padding: theme.spacing(0),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  value: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightMedium,

    fontFamily: "inherit",
    width: "100%",
    borderBottom: "none",
    whiteSpace: "normal",
    wordBreak: "break-word",
    color: "inherit",
    padding: (props) => {
      return theme.spacing(props.compact ? 0 : 1);
    },
  },
  definitionList: {},
  definition: {},
}));

function Definition({
  def,
  value,
  align = "left",
  defAlign = "right",
  compact = false,
}) {
  const classes = useStyles({ compact });
  return (
    <TableRow className={classes.definition}>
      <TableCell
        align={defAlign}
        component="th"
        scope="row"
        className={classes.def}
      >
        {def}
        {value ? ":" : ""}
      </TableCell>
      <TableCell align={align} className={classes.value}>
        {value}
      </TableCell>
    </TableRow>
  );
}

function DefinitionHeading({ def }) {
  const classes = useStyles();
  return (
    <TableRow className={classes.definition}>
      <TableCell
        component="th"
        scope="row"
        className={classes.heading}
        colSpan={2}
      >
        {def}
      </TableCell>
    </TableRow>
  );
}

function DefinitionList({ children }) {
  const classes = useStyles();
  return (
    <Table>
      <TableBody className={classes.definitionList}>{children}</TableBody>
    </Table>
  );
}

export { Definition, DefinitionList, DefinitionHeading };
